import { render, staticRenderFns } from "./access-deny.vue?vue&type=template&id=228197d8&"
import script from "./access-deny.vue?vue&type=script&lang=js&"
export * from "./access-deny.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/iy_web_test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('228197d8')) {
      api.createRecord('228197d8', component.options)
    } else {
      api.reload('228197d8', component.options)
    }
    module.hot.accept("./access-deny.vue?vue&type=template&id=228197d8&", function () {
      api.rerender('228197d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/error-page/access-deny.vue"
export default component.exports